import { Typography, Paper, Tabs, Tab } from '@material-ui/core'
import React, { useState, useEffect } from 'react'
import { OrganizationsClient, OrganizationResponseDTO } from '../generated/ApiClient'
import { RouteComponentProps } from 'react-router'
import OrganizationForm from './OrganizationForm'
import OrganizationUsers from './OrganizationUsers'
import Subgroups from './Subgroups'
import TabPanel from '../common/TabPanel'
import { Sites } from './Sites'
import EmailList from './EmailList'
import { Modems } from './Modems'
import CenteredProgress from '../common/CenteredLoader'
import { useIsUserInRoles, OrgEmailViewer, SubGroupViewer } from '../hooks/useIsUserInRoles'

const AboutTabValue = 0;
const SitesTabValue = 1;
const SubgroupsTabValue = 2;
const MembersTabValue = 3;
const ModemsTabValue = 4;
const EmailsTabValue = 5;

export default function OrganizationDetails(props: { organizationId: string } | RouteComponentProps<{ organizationId: string }>) {
    const organizationId = 'organizationId' in props ? props.organizationId : props.match.params.organizationId
    const [orgData, setOrgData] = useState<OrganizationResponseDTO | 'Loading' | undefined>('Loading')
    const [value, setValue] = React.useState(0)
    // org members should be able to see all members of subgroups they are in, but this would require an API change so for now hide this
    const canViewEmailsAndMembers = useIsUserInRoles(OrgEmailViewer)
    const canViewSubgroups = useIsUserInRoles(SubGroupViewer)
    function tabHandler(event: React.ChangeEvent<{}>, newValue: number) {
        setValue(newValue);
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const selectedOrg = await new OrganizationsClient().get3(organizationId);
                setOrgData(selectedOrg);
            }
            catch {
                setOrgData(undefined);
            }
        }
        fetchData();
    }, [organizationId, setOrgData])

    if (orgData === 'Loading') {
        return <CenteredProgress />
    }
    else if (orgData) {
        return (
            <>
                <Typography variant='h4' id="tabelLabel">{orgData.name}</Typography>
                <Paper square>
                    <Tabs
                        value={value}
                        onChange={tabHandler}
                        variant="scrollable"
                        scrollButtons="auto"
                    >
                        <Tab label="About" value={AboutTabValue} />
                        <Tab label="Sites" value={SitesTabValue} />
                        {canViewSubgroups && <Tab label="Subgroups" value={SubgroupsTabValue} />}
                        {canViewEmailsAndMembers && <Tab label="Members" value={MembersTabValue} />}
                        <Tab label="Modems" value={ModemsTabValue} />
                        {canViewEmailsAndMembers && <Tab label="Allowed Email Domains" value={EmailsTabValue} />}
                    </Tabs>
                </Paper>
                <TabPanel value={value} index={AboutTabValue}>
                    <OrganizationForm externalId={orgData.externalId}></OrganizationForm>
                </TabPanel>
                <TabPanel value={value} index={SitesTabValue}>
                    <Sites organizationId={orgData.externalId} />
                </TabPanel>
                {canViewSubgroups &&
                    <TabPanel value={value} index={SubgroupsTabValue}>
                        <Subgroups organizationId={orgData.externalId}></Subgroups>
                    </TabPanel>}
                {canViewEmailsAndMembers &&
                    <TabPanel value={value} index={MembersTabValue}>
                        <OrganizationUsers organizationId={orgData.externalId}></OrganizationUsers>
                    </TabPanel>}
                <TabPanel value={value} index={ModemsTabValue}>
                    <Modems organizationId={orgData.externalId}></Modems>
                </TabPanel>
                {canViewEmailsAndMembers &&
                    <TabPanel value={value} index={EmailsTabValue}>
                        <EmailList organizationId={orgData.externalId}></EmailList>
                    </TabPanel>}
            </>
        )
    } else {
        return (
            <>
                <Typography variant='h4' id="tabelLabel">Organization Not Found</Typography>
            </>
        )
    }
}
